import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=bd49109c&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd49109c')) {
      api.createRecord('bd49109c', component.options)
    } else {
      api.reload('bd49109c', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=bd49109c&", function () {
      api.rerender('bd49109c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22M0Ip99fHjKm/JS/comp/pricelist.vue"
export default component.exports